import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-template-bmc-component',
    standalone: false,
    templateUrl: './template-bmc-component.component.html',
    styleUrl: './template-bmc-component.component.scss'
})
export class TemplateBmcComponentComponent {
    @Input({ required: true }) data: { title: string, question: string, answers: string[], dirty: boolean }[] = [];
    @Input({ required: true }) state: boolean = false;

}
